export const PREVIEW_NEW_HIRE_EXPERIENCE_PATH = '/preboarding/preview/:stepId?';
